import {mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreWrapperWithLineClamp} from "../../../atoms/ShowMoreWrapperWithLineClamp";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {IVendorDetail} from "../../types/IVendorDetail";
import {VendorDetailGeneratedDescription} from "./VendorDetailGeneratedDescription";
import {VendorDetailRecommendation} from "./VendorDetailRecommendation";

interface IProps {
    vendor: IVendorDetail;
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
    }[];
    housesOffers: {
        name: string;
    }[];
    commercialsOffers: {
        name: string;
    }[];
}

export const VendorDetailDescription = (props: IProps) => {
    const {vendor, variables, flatsOffers, housesOffers, commercialsOffers} = props;
    const shouldGenerateAdditionalDescription = !vendor.description || vendor.description.length < 300;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(5), onDesktop(mb(7))]}>
                Informacje o nas
            </Text>

            {vendor.recommendation && <VendorDetailRecommendation vendor={vendor} variables={variables} />}

            <ShowMoreWrapperWithLineClamp maxLinesToShow={8}>
                {vendor.description && (
                    <>
                        {vendor.description.split("\n").map((item, key) => (
                            <Text key={key} as="p" variant="body_copy_2" mb={0.5}>
                                {item.trim()}
                            </Text>
                        ))}
                    </>
                )}

                {shouldGenerateAdditionalDescription && (
                    <VendorDetailGeneratedDescription
                        vendor={vendor}
                        variables={variables}
                        flatsOffers={flatsOffers}
                        housesOffers={housesOffers}
                        commercialsOffers={commercialsOffers}
                    />
                )}
            </ShowMoreWrapperWithLineClamp>
        </>
    );
};
import {mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreWrapperWithLineClamp} from "../../../atoms/ShowMoreWrapperWithLineClamp";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {IVendorDetail} from "../../types/IVendorDetail";
import {VendorDetailGeneratedDescription} from "./VendorDetailGeneratedDescription";
import {VendorDetailRecommendation} from "./VendorDetailRecommendation";

interface IProps {
    vendor: IVendorDetail;
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
    }[];
    housesOffers: {
        name: string;
    }[];
    commercialsOffers: {
        name: string;
    }[];
}

export const VendorDetailDescription = (props: IProps) => {
    const {vendor, variables, flatsOffers, housesOffers, commercialsOffers} = props;
    const shouldGenerateAdditionalDescription = !vendor.description || vendor.description.length < 300;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(5), onDesktop(mb(7))]}>
                Informacje o nas
            </Text>

            {vendor.recommendation && <VendorDetailRecommendation vendor={vendor} variables={variables} />}

            <ShowMoreWrapperWithLineClamp maxLinesToShow={8}>
                {vendor.description && (
                    <>
                        {vendor.description.split("\n").map((item, key) => (
                            <Text key={key} as="p" variant="body_copy_2" mb={0.5}>
                                {item.trim()}
                            </Text>
                        ))}
                    </>
                )}

                {shouldGenerateAdditionalDescription && (
                    <VendorDetailGeneratedDescription
                        vendor={vendor}
                        variables={variables}
                        flatsOffers={flatsOffers}
                        housesOffers={housesOffers}
                        commercialsOffers={commercialsOffers}
                    />
                )}
            </ShowMoreWrapperWithLineClamp>
        </>
    );
};
